export default "<template>\n\n  <KTextbox\n    label=\"Disabled input\"\n    disabled\n  />\n\n</template>\n";